import { render, staticRenderFns } from "./manualsgc.vue?vue&type=template&id=b7e900fe&scoped=true&"
import script from "./manualsgc.vue?vue&type=script&lang=js&"
export * from "./manualsgc.vue?vue&type=script&lang=js&"
import style0 from "./manualsgc.vue?vue&type=style&index=0&id=b7e900fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e900fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7e900fe')) {
      api.createRecord('b7e900fe', component.options)
    } else {
      api.reload('b7e900fe', component.options)
    }
    module.hot.accept("./manualsgc.vue?vue&type=template&id=b7e900fe&scoped=true&", function () {
      api.rerender('b7e900fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manualsgc.vue"
export default component.exports